<template>
  <div class="container w100 relative-container">
    <div class="padded">
      <wrap-container class="w50-fixed">
        <form-validator>
          <step-header v-if="!embeded" />
          <wrap-container class="grid-container grid-container--6-6">
            <custom-search-selector
              class="col1"
              v-model="model.lugarNacimiento"
              name="paisNacimiento"
              label="País de nacimiento"
              subhint="Ingrese su país de nacimiento"
              :items="nacionalidades"
              :required="true"
              quantumObfuscate
            />

            <civil-status
              class="col2"
              v-model="model.estadoCivil"
              quantumObfuscate
            />
          </wrap-container>

          <wrap-container v-show="reqEstCivilData">
            <section-label value="Datos del cónyuge" />
            <div class="grid-container grid-container--6-6">
              <text-input
                class="col1"
                label="Nombre"
                name="conyuge.nombre"
                v-model="model.conyuge.nombre"
                :required="reqEstCivilData"
                quantumObfuscate
              />
              <text-input
                class="col2"
                label="Apellido"
                name="conyuge.apellido"
                v-model="model.conyuge.apellido"
                :required="reqEstCivilData"
                quantumObfuscate
              />
            </div>
          </wrap-container>

          <wrap-container class="grid-container grid-container--6-6">
            <div v-show="reqEstCivilData" class="col1">
              <dni-input
                label="Número de documento"
                hint="Ej: 28956372"
                inputName="conyuge.numeroDoc"
                v-model="model.conyuge.numeroDoc"
                :required="reqEstCivilData"
                maxlength="8"
                :tipoDoc.sync="model.conyuge.tipoDoc"
                quantumObfuscate
              />
            </div>
          </wrap-container>

          <p id="subtitulo" class="titulo oscuro">
            Aquí es donde te enviaremos tu resumen digital y notificaciones.
          </p>
          <wrap-container>
            <section-label value="Domicilio particular" />
            <address-data quantumObfuscate v-model="modelDomicilio" />
          </wrap-container>
          <step-navigator
            v-model="modelAction"
            :disable="deshabilitarBoton"
            store-action="DO_DATOS_PERSONALES"
            :routerPush="false"
            analyticsName="continuar"
          />
        </form-validator>
      </wrap-container>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { get } from "../utils";
import { nacionalidades } from "@/config/constants";
import WrapContainer from "@/components/core/Container";
import FormValidator from "@/components/core/FormValidator";
import StepHeader from "@/components/core/StepHeader";
import SectionLabel from "@/components/core/SectionLabel";
import DniInput from "@/components/core/composite/DniInput";
import TextInput from "@/components/core/TextInput";
import CivilStatus from "@/components/core/composite/combos/CivilStatus";
import AddressData from "@/components/core/AddressData";
import StepNavigator from "@/components/core/StepNavigator";
import CustomSearchSelector from "@/components/core/custom/CustomSearchSelector";
import { DO_CONSULTAR_DOMICILIO } from "@/config/constants/action-types";

export default {
  name: "DatosPersonales",
  components: {
    WrapContainer,
    FormValidator,
    StepHeader,
    TextInput,
    SectionLabel,
    DniInput,
    CivilStatus,
    AddressData,
    StepNavigator,
    CustomSearchSelector
  },
  props: {
    embeded: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      model: this.$store.getters.getDatosPersonales(),
      modelDomicilio: this.$store.getters.getDomicilio(),
      deshabilitarBoton: false,
      nacionalidades: nacionalidades
    };
  },
  computed: {
    ...mapState({
      // Propiedades de estado existentes
      forzarDNE: state => {
        return get(state, "forzarDNE['conyuge.numeroDoc']", false);
      },
      modelAction() {
        return { model: this.model, modelDomicilio: this.modelDomicilio };
      }
    }),
    reqEstCivilData() {
      return this.model.estadoCivil === "1";
    }
  },
  mounted() {
    // Autcompletado País de Nacimiento
    const {
      numeroDoc,
      nacionalidad,
      circuito
    } = this.$store.getters.getConsulta();
    if (Number(numeroDoc) < 90000000 || nacionalidad != "80") {
      this.model.lugarNacimiento =
        nacionalidades.find(item => item.value === nacionalidad)?.label ?? "";
    }

    // Consultar domicilios
    this.$store.dispatch(DO_CONSULTAR_DOMICILIO);

    // Watch del domicilio
    this.$store.watch(
      this.$store.getters.getDomicilio,
      model => {
        this.modelDomicilio = model;
      },
      { immediate: true }
    );

    if (circuito == "NOM") this.config.cantPasos = 9;

    // Watch del model
    this.$store.watch(
      this.$store.getters.getDatosPersonales,
      model => {
        this.model = model;
      },
      { immediate: true }
    );
  }
};
</script>
